import { useEffect, useState } from "react";
import { Button } from "@mui/material";
import {
  Switch,
  FormControlLabel,
  TextField,
  Grid,
  CardActions,
  CardContent,
  CardHeader,
  Card,
  Loading,
} from "../../../components";
import { GrupoProdutosService, notification } from "../../../services";
import { InputErros, PermisoesHelper } from "../../../helpers";
import { responseErros } from "../../../utils";
import grupoProdutosValidator from "./middlewares/grupoProdutos.validator";
import { GrupoProdutoEntity } from "../entities";

const AddGrupoProdutos = ({
  id,
  handleCloseDialog,
  buscaGruposProdutos,
  isFullscreenDialog,
  handleCloseFullscreenDialog,
}) => {
  const permissoesHelper = new PermisoesHelper();
  permissoesHelper.validarPermisao("grupo-produtos-visualizar");
  const [loading, setLoading] = useState(false);
  const [grupoProdutos, setGrupoProdutos] = useState({
    ativado: true,
  });
  const [inputErro, setInputErro] = useState([]);
  const inputErros = new InputErros(inputErro, setInputErro);
  const grupoProdutosService = new GrupoProdutosService();

  useEffect(() => {
    if (id) {
      buscaGrupoProduto(id);
    }
  }, []);

  const buscaGrupoProduto = async (id) => {
    const response = await grupoProdutosService.getById(id);
    setGrupoProdutos(response.data);
  };

  const handleInputChange = (event) => {
    setGrupoProdutos((prevState) => ({
      ...prevState,
      [event.target.name]: event.target.value,
    }));
  };

  const handleSubmit = async () => {
    setLoading(true);
    grupoProdutosValidator
      .validate(grupoProdutos, { abortEarly: false })
      .then(async () => {
        const grupoProdutoEntity = new GrupoProdutoEntity(grupoProdutos);
        if (id) {
          const response = await grupoProdutosService.atualizar(
            id,
            grupoProdutoEntity
          );
          setLoading(false);
          if (!response.isAxiosError) {
            handleCloseDialog();
            notification.alteracaoSucesso();
            buscaGruposProdutos();
          } else {
            responseErros(response);
          }
        } else {
          const response = await grupoProdutosService.cadastrar(
            grupoProdutoEntity
          );
          setLoading(false);
          if (!response.isAxiosError) {
            if (!isFullscreenDialog) {
              handleCloseDialog();
              notification.cadastroSucesso();
              buscaGruposProdutos();
            } else {
              handleCloseFullscreenDialog();
            }
          } else {
            responseErros(response);
          }
        }
      })
      .catch((err) => {
        setLoading(false);
        inputErros.set(err);
      });
  };

  const handleCancelar = () => {
    setGrupoProdutos(null);
    if (isFullscreenDialog) {
      handleCloseFullscreenDialog();
    } else handleCloseDialog();
  };

  return (
    <>
      <Card className="p-3">
        <CardHeader
          title={
            id ? "Editar Grupo de Produtos" : "Cadastrar Grupo de Produtos"
          }
          action={
            <FormControlLabel
              control={
                <Switch
                  checked={
                    grupoProdutos?.ativado ? grupoProdutos?.ativado : false
                  }
                  onChange={() =>
                    setGrupoProdutos((prevState) => ({
                      ...prevState,
                      ativado: !prevState?.ativado,
                    }))
                  }
                  name="ativado"
                  color="primary"
                />
              }
              label={grupoProdutos?.ativado ? "Ativado" : "Desativado"}
            />
          }
        />
        <CardContent>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <TextField
                id="descricao"
                name="descricao"
                label="Descrição"
                variant="outlined"
                value={grupoProdutos?.descricao ? grupoProdutos.descricao : ""}
                onChange={(event) => {
                  setInputErro([]);
                  handleInputChange(event);
                }}
                fullWidth
                required
                error={inputErros.get("descricao")}
              />
            </Grid>
          </Grid>
        </CardContent>
        <CardActions>
          <Button
            color="primary"
            variant="contained"
            disabled={!permissoesHelper.temPermisao("grupo-produtos-cadastrar")}
            onClick={handleSubmit}
          >
            <i
              className="ph-fill ph-check-circle"
              style={{ fontSize: 22, marginRight: 10 }}
            ></i>
            Salvar
          </Button>
          <Button color="padrao" variant="contained" onClick={handleCancelar}>
            <i
              className="ph-fill ph-x-circle"
              style={{ fontSize: 22, marginRight: 10 }}
            ></i>
            Fechar
          </Button>
        </CardActions>
      </Card>
      <Loading loading={loading} />
    </>
  );
};

export default AddGrupoProdutos;
